export default __webpack_public_path__ + "static/media/tutorialWeb-4.6.58b482c9.png";